import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import { InputText, Form, Button, Spin } from "common/elements";
import { getOne, insertNewRecord, updateRecordById } from "services/project";

export default class FormModal extends React.PureComponent {
  state = {
    isModalVisible: false,
    id: null,
    loading: false,
    disabled: false,
    loadingFormData: false,
  };

  showModal = (id) => {
    if (id) {
      this.setState({ loadingFormData: true, isModalVisible: true });
      getOne(id)
        .then((response) => {
          if (response) {
            const formData = response.data;
            this.props.form.setFieldsValue({
              code: formData.code,
              title: formData.title,
            });
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            this.props.navigate("/signin");
          }
        })
        .finally(() => {
          this.setState({
            isModalVisible: true,
            id,
            loadingFormData: false,
          });
        });
    } else {
      this.setState({
        isModalVisible: true,
        id: null,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      isModalVisible: false,
      disabled: false,
    });
  };

  onFinish = (values) => {
    this.setState({ loading: true, disabled: true });
    if (this.state.id) {
      updateRecordById(this.state.id, values)
        .then(() => {
          this.setState({
            isModalVisible: false,
          });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    } else {
      insertNewRecord(values)
        .then(() => {
          this.setState({
            isModalVisible: false,
          });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    const { isModalVisible, loading, loadingFormData, disabled, id } =
      this.state;
    return isModalVisible ? (
      <Modal
        title={id ? t("text_edit_donor") : t("text_new_donor")}
        visible={isModalVisible}
        onCancel={this.handleCancel}
        style={{ top: 20 }}
      >
        <Spin spinning={loadingFormData}>
          <Form
            form={this.props.form}
            onFinish={this.onFinish}
            layout="vertical"
            onFinishFailed={this.onFinishFailed}
            key={id}
          >
            <InputText
              name="title"
              label={t("text_donor_name")}
              placeholder={t("text_what_is_your_donor_name")}
              requiredMessage={t("text_please_input_donor_name")}
              isAutoSelect={true}
            />
            <InputText
              name="code"
              label={t("text_project_no")}
              placeholder={t("text_enter_your_project_no")}
              requiredMessage={t("text_please_input_project_no")}
              isAutoSelect={true}
            />
            <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={this.handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t("text_save")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    ) : (
      <div />
    );
  }
}
